import { MutationTree, Module, GetterTree, ActionTree } from "vuex";
import * as firebase from "firebase/app";
import "firebase/auth";
import { GlobalState } from "./state";
import { Role, OrejasUser, RoleCustomer } from "./users";
import { getLoggedUser } from "@/lib/auth";
import { client } from "@/lib/client";

export type AuthState = {
  currentRole?: Role;
  error?: Error;
  currentUser: LoggedUser;
};

export type LoggedUser = {
  user?: OrejasUser;
  firebaseUser?: firebase.User;
};

const mutations: MutationTree<AuthState> = {
  SET_USER(state, userCurrent: LoggedUser) {
    state.currentUser = userCurrent;
  },
  SET_ERROR(state, err: Error) {
    state.error = err;
  },
  CLEAR_ERROR(state) {
    state.error = undefined;
  },
  CLEAR_ALL(state) {
    state.currentUser.firebaseUser = undefined;
    state.currentUser.user = undefined;
  },
  SET_ROLES(state, role: Role) {
    state.currentRole = role;
  },
  SET_CURRENT_CUSTOMER_USER(state, customer: RoleCustomer) {
    if (state.currentUser.user) {
      state.currentUser.user.customerCurrent = customer;
      state.currentRole = customer.role;
    }
  },
};

const actions: ActionTree<AuthState, GlobalState> = {
  async getDataUserCurrent({ commit }) {
    const res = await getLoggedUser(client);
    commit("SET_CURRENT_USER", res);
  },
};

const getters: GetterTree<AuthState, GlobalState> = {
  userName({ currentUser }) {
    if (currentUser.firebaseUser) {
      return currentUser.firebaseUser.displayName;
    }
  },
  isSuperAdmin({ currentRole, currentUser }): boolean {
    if (!currentUser.firebaseUser || !currentRole) {
      return false;
    }
    return currentRole == "superAdmin";
  },
  isClientAdmin({ currentRole, currentUser }): boolean {
    if (!currentUser.firebaseUser || !currentRole) {
      return false;
    }
    return currentRole == "customerAdmin";
  },
  isLoggedIn(state): boolean {
    if (state.currentUser.firebaseUser) {
      return true;
    }
    return false;
  },
};

const state: AuthState = {
  currentRole: undefined,
  currentUser: {},
  error: undefined,
};

export const authModule: Module<AuthState, GlobalState> = {
  mutations,
  state,
  getters,
  actions,
  namespaced: true,
};
